export default {
    goals: {
        list: {
            title: 'Goals'
        },
        tableHeaders: [
            { text: 'Full Name', value: 'fullName', sortable: false },
            {
                text: 'Business',
                value: 'businessName',
                sortable: false,
                filter: 'businessNames'
            },
            { text: 'Longest streak', value: '', sortable: false },
            {
                text: 'Completed',
                value: 'completed',
                sortable: false
            }
        ],
        mobile: {
            filter: {
                businessNames: {
                    name: 'Filter by Business',
                    value: 'businessName'
                }
            }
        }
    }
};
